<template>
    <!-- Default Layout -->
    <div>
        <SidebarTest />
        <div class="content">
          <!-- <transition name="router-anim"> -->
                <slot />
            <!-- </transition> -->
        </div>
        <NotificationList />
        <v-tour 
            name="myTour" 
            :steps="steps" 
            :options="myOptions" 
            :callbacks="vTourCallbacks">
        </v-tour>
        <v-tour 
            name="tmzTour" 
            :steps="tmzTourSteps" 
            :options="myOptions" 
            :callbacks="vTourCallbacks">
        </v-tour>
    </div>
</template>

<script>
import SideBar from './SideBar.vue'
import TopNavBar from '@/components/TopNavBar.vue'
import NotificationList from "@/components/NotificationList.vue"
import SidebarTest from '@/components/Sidebar.vue'

    export default {
        data() {
            return {
                vTourCallbacks: {
                    onSkip: this.handleTourCancel,
                    onFinish: this.handleTourFinish
                },
                myOptions: {
                    useKeyboardNavigation: false,
                    highlight: true,
                    labels: {
                        buttonSkip: 'Пропустить',
                        buttonPrevious: 'Предыдущий',
                        buttonNext: 'Следующий',
                        buttonStop: 'Завершить'
                    }
                },
                steps: [
                    {
                        target: '#v-step-main',
                        header: {
                        title: 'Главная',
                        },
                        content: `В разделе Главная, отображается информация по движению ТМЦ и ОС по вашей организации, а также Информация о ценах реализации черного и цветного металлолома по группе компаний КМГ.`
                    },
                    {
                        target: '#v-step-0',  // We're using document.querySelector() under the hood
                        header: {
                        title: 'Отчеты',
                        },
                        content: `В разделе <strong>отчеты</strong> Вы можете сформировать отчеты по металлолому нажав на "Формирование отчета", посмотреть подписанные Вами отчеты по металлолому нажав на "Мои отчеты металлом", а также посмотреть подписанные отчеты по металлолому Вашей организации нажав на "Другие отчеты"`
                    },
                    {
                        target: '#v-step-1',
                        header: {
                        title: 'ТМЗ',
                        },
                        content: `В разделе <strong>ТМЗ</strong> Вы можете сформировать отчеты по ТМЗ нажав на "Формирование ТМЗ", посмотреть подписанные Вами отчеты по ТМЗ нажав на "Мои отчеты ТМЗ", а также посмотреть подписанные отчеты по ТМЗ Вашей организации нажав на "Отчеты ТМЗ"!`
                    },
                    {
                        target: '#v-step-2',
                        header: {
                        title: 'Поиск ТМЗ',
                        },
                        content: `Поиск ТМЗ, на этой странице Вы можете произвести поиск по НВЛ и НЛ товарно-материальных запасов группы компаний КМГ`
                    },
                    {
                        target: '#v-step-3',
                        header: {
                        title: 'Поиск',
                        },
                        content: `Выберите необходимые фильтры (Год, месяц или квартал/полугодие) и нажмите на кнопку "Поиск" для того, чтобы сформировать итоговые показатели по отчетам ТМЗ.`
                    },
                    {
                        target: '#v-step-4',
                        header: {
                        title: 'Профиль',
                        },
                        content: `В разделе Профиль, Вы можете посмотреть личную карту пользователя и коллег по Вашей организации.`
                    },
                    {
                        target: '#v-step-5',
                        header: {
                        title: 'Обучение',
                        },
                        content: `В разделе Обучение, Вы можете скачать шаблоны по загрузке отчетов ТМЗ, скачать инструкции по сдаче отчетности ТМЗ и металлолома, ознакомиться с F.A.Q, а также получить контакты тех.поддержки.`
                    },
                    {
                        target: '#v-step-6',
                        header: {
                        title: 'Чат',
                        },
                        content: `В разделе Чат, Вы можете напрямую обратиться к тех. поддержке по поводу возникших проблем`
                    },
                    {
                        target: '#v-step-7',
                        header: {
                        title: 'Выйти',
                        },
                        content: `Выйти, для того чтобы осуществить выход из системы`
                    },
                ],
                tmzTourSteps: [
                    {
                        target: '#v-step-tmz-skip',
                        header: {
                        title: 'Пропустить',
                        },
                        content: `Нажмите на кнопку "Пропустить" если у Вас нет остатков по востребованному ТМЗ/Невостребованному ликвиду и Неликвидам`
                    },
                    {
                        target: '#v-step-tmz-download-template',
                        header: {
                        title: 'Скачать шаблон',
                        },
                        content: `Нажмите на кнопку "Скачать шаблон" для того, чтобы скачать загружаемый шаблон по текущему шагу`
                    },
                ]
            }
        },
        mounted() {
            let hasVisited = localStorage.getItem('hasVisited');
            console.log(hasVisited)
            if (!hasVisited) {
                this.$tours['myTour'].start()
            }
        },
        components: {
            SideBar,
            NotificationList,
            SidebarTest
        },
        methods: {
            handleTourFinish() {
                if (this.$route.name === 'home') {
                    localStorage.setItem('hasVisited', 'true');
                } else {
                    localStorage.setItem('hasVisitedTmz', 'true');
                }
            },
            handleTourCancel() {
                if (this.$route.name === 'home') {
                    localStorage.setItem('hasVisited', 'true');
                } else {
                    localStorage.setItem('hasVisitedTmz', 'true');
                }
            }
        },
        computed: {
            loggedIn() {
                return this.$store.getters.loggedIn
            },
        },
    }
</script>

<style lang="scss">
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
.content {
    position: relative;
    min-height: 100vh;
    left: 260px;
    width: calc(100% - 260px);
    transition: all .3s ease;
}

.sidebar.close ~ .content {
    left: 78px !important;
    width: calc(100% - 78px) !important;
}

.dropzone {
  margin-top: 3rem;
  height: 250px;
  min-height: 250px;
  padding: 10px;
  position: relative;
  cursor: pointer;
  border: 5px dashed #dddddd;
  outline-offset: 10px;
  background: lightcyan;
  color: dimgray;
}

.input-field {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}

.dropzone:hover {
  background: lightblue;
  transition: all 300ms ease;
}

.dropzone .call-to-action {
  font-size: 1.5rem;
  text-align: center;
  padding: 70px 0;
}

.call-to-action > div {
  font-size: 1rem;
  padding: 1rem 2rem;
  background: #00d1b2;
  max-width: 300px;
  margin: 1rem auto;
  border-radius: 20px;
  color: #fff;
}

.table-container-inner::-webkit-scrollbar {
  width: 0.25rem;
  width: 13px;
  height: 13px;
}

.table-container-inner::-webkit-scrollbar-thumb {
  background: #e3e3e3;
  border-radius: 100px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.router-anim-enter-active {
    animation: coming .5s;
    animation-delay: 1s;
    opacity: 0;
}

.router-anim-leave-active {
    animation: going .5s;
}

@keyframes going {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-50px);
        opacity: 0;
    }
}

@keyframes coming {
    from {
        transform: translateX(-50px);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4) !important;
}
</style>
